import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { Formatter } from './Formatter';

dayjs.extend(timezone);
dayjs.extend(advancedFormat);
dayjs.extend(utc);

export const TableFormatHelper = {
    formatDateTime(iso8601Time: string): string {
        if (!iso8601Time) {
            return '';
        }
        const dt = dayjs(iso8601Time);
        return dt.format(Formatter.defaultDateTimeFormat);
    },

    formatDate(value: string): string {
        if (!value) {
            return '';
        }
        return Formatter.convertDateToStandardFormatDateStr(value);
    },

    formatDateTimeCellValue(item: any, header: { value: string; format?: string }): string {
        const value = item[header.value];
        if (header.format === 'datetime') {
            return TableFormatHelper.formatDateTime(value);
        }
        if (header.format === 'date') {
            return TableFormatHelper.formatDate(value);
        }
        return value;
    }
};

